import styled from '@emotion/styled';
import broomEmojiUrl from '@/assets/apple-emoji/broom.png?url';
import lockEmojiUrl from '@/assets/apple-emoji/lock.png?url';
import packageEmojiUrl from '@/assets/apple-emoji/package.png?url';
import robotEmojiUrl from '@/assets/apple-emoji/robot.png?url';
import rocketEmojiUrl from '@/assets/apple-emoji/rocket.png?url';
import searchEmojiUrl from '@/assets/apple-emoji/search.png?url';
import shieldEmojiUrl from '@/assets/apple-emoji/shield.png?url';

const Bullets = styled.ul`
  margin: 0;
  list-style: none;
  padding: 0;
  display: grid;
  gap: 14px;
  font-size: 18px;
  font-weight: 500;
  letter-spacing: 0.87px;
  color: #141414;
  text-align: left;
  width: 100%;
`;

const ListItem = styled.li`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export type FeatureIcon = '🛡️' | '🤖' | '🔍' | '🚀' | '🧹' | '🔒' | '📦';

const FEATURE_ICON_URLS: Record<FeatureIcon, string> = {
  '🛡️': shieldEmojiUrl,
  '🤖': robotEmojiUrl,
  '🔍': searchEmojiUrl,
  '🚀': rocketEmojiUrl,
  '🧹': broomEmojiUrl,
  '🔒': lockEmojiUrl,
  '📦': packageEmojiUrl,
};

const Icon = styled.img`
  width: 30px;
  height: 30px;
  display: block;
  flex: 0 0 30px;
  object-fit: contain;
  vertical-align: middle;
`;

export interface FeatureItem {
  icon: FeatureIcon;
  text: string;
}

interface FeatureListProps {
  features: FeatureItem[];
}

export function FeatureList({ features }: FeatureListProps) {
  return (
    <Bullets>
      {features.map((feature, idx) => (
        <ListItem key={idx}>
          <Icon src={FEATURE_ICON_URLS[feature.icon]} alt="" aria-hidden="true" />
          <span>{feature.text}</span>
        </ListItem>
      ))}
    </Bullets>
  );
}
